import { GetRequestParams } from '@/ship/Requests/RequestParams';
import Http from '@/ship/Http';
import ITransformedValue from '@/ship/Values/ITransformedValue';
import User from '@/ship/Models/User';

export interface IHistory {
    id: number;
    authorId: number;
    updatedAt: string;
    createdAt: string;
    author?: ITransformedValue<User>;
    message?: string;
    submessage?: string;
}

export const getAdministrationHistory = <D = IHistory>(id: number, fieldName: string, params?: GetRequestParams) =>
    Http.get<ITransformedValue<D[]>>(`projects/${id}/${fieldName}`, { params });
